import { useState } from 'react';
import { SERVER_URL } from '../../../config';
import service from '../../../services/userService';
import ModalBackdrop from './ModalBackdrop';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Link, Stack, Typography } from '@mui/material';

interface PolicyModalProps {
  userId: string;
  termsConsent: boolean;
  updateAuthUser: (data: { noShowConsent: boolean; termsConsent: boolean }) => void;
  onClose?: () => void;
}

const PolicyModal = (props: PolicyModalProps) => {
  const [termsChecked, setTermsChecked] = useState(false);

  const onSubmit = async () => {
    const data = {
      noShowConsent: true,
      termsConsent: true,
    };
    try {
      await service.updateProfile(data, props.userId);
      props.updateAuthUser(data);
    } catch (error) {
      props.updateAuthUser(data);
      console.log(error);
    }
  };

  return (
    <ModalBackdrop>
      <Dialog 
        open={true}
        PaperProps={{ sx: { padding: '22px 32px' } }}
      >
        <DialogTitle fontWeight="bold" sx={{ textAlign: 'center' }}>Updated Terms</DialogTitle>
        {!props.termsConsent && (
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1 }}>
            <Typography>
              We have recently updated our terms and conditions, including a new no-show policy. Please read and agree to the following:
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={termsChecked}
                  onChange={(e) => setTermsChecked(e.target.checked)}
                />
              }
              label="I've read and agreed to the following:"
            />

            <Stack direction="column" spacing={0.5}>
              <Button variant='text' href={`${SERVER_URL}/conditions/privacy-policy`} target="_blank" rel="noreferrer">
                Privacy Policy
              </Button>
              <Button variant='text' href={`${SERVER_URL}/conditions/notice-of-privacy-practices`} target="_blank" rel="noreferrer">
                Notice of Privacy Practices
              </Button>
              <Button variant='text' href={`${SERVER_URL}/conditions/terms-of-use`} target="_blank" rel="noreferrer">
                Terms of Use
              </Button>
              <Button variant='text' href={`${SERVER_URL}/conditions/end-user-agreement`} target="_blank" rel="noreferrer">
                End User License Agreement
              </Button>
            </Stack>
          </DialogContent>
        )}
        <DialogActions sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, mt: 2 }}>
          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={!props.termsConsent && !termsChecked}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </ModalBackdrop>
  );
};

export default PolicyModal; 